const _elementPairs = [
    {
      blockSelector: '#restock-rocket-inline-container',
      appSelector: '.restock-rocket-wrapper-inline'
    },
    {
        blockSelector: '#ProductAccordion-collapsible-row-2-template--23894811410700__main > p',
        appSelector: '#sku-label'
    },
    {
        blockSelector: '#GalleryViewer-template--18452109230348__main modal-opener',
        appSelector: '#Share-template--18452109230348__main'
    },
    {
        blockSelector: '#sticky-add-to-cart .price-wrapper',
        appSelector: '#price-template--18452109230348__main'
    },
    {
        blockSelector: '#sticky-add-to-cart .price-wrapper',
        appSelector: '#price-template--19431083475212__main'
    },
    {
        blockSelector: '#sticky-add-to-cart .price-wrapper',
        appSelector: '.product__tax'
    },
    {
        blockSelector: '#sticky-add-to-cart',
        appSelector: 'product-form[data-section-id="template--18452109230348__main"]'
    },
    {
        blockSelector: '#sticky-add-to-cart',
        appSelector: 'product-form[data-section-id="template--19431083475212__main"]'
    }  
];

const elementPairs = [
  {
    blockSelector: '[id^=ProductInfo-template--] h2',
    appSelector: '[id^=ProductInfo-template--] #restock-rocket-inline-container',
    type: 'append'
  },
  {
    blockSelector: '[id^=MediaGallery-template]',
    appSelector: '[id^=Share-template--]',
    type: 'append'
  },
  {
      blockSelector: '.product__info-container.product__column-sticky [id^=ProductAccordion-collapsible-row-2-template]',
      appSelector: '#sku-label',
      type: 'prepend'
  },
  {
     blockSelector: '#sticky-add-to-cart .price-wrapper',
     appSelector: '.product__info-container.product__column-sticky [id^=price-template--]',
     type: 'append'
  },
  {
    blockSelector: '#sticky-add-to-cart .price-wrapper',
    appSelector: '.product__tax',
    type: 'append'
  },
  {
    blockSelector: '#sticky-add-to-cart',
    appSelector: '.product__info-container.product__column-sticky product-form',
    type: 'append'
  }
]

var mutationsSelectors = [
  { 
    target: '.product__info-container', from: 'wishlist-button-block', to: '.product__column-sticky',
  }
];

let operationCount = elementPairs.length;
let operationsCompleted = 0;

const pfInterval = setInterval(() => {
    elementPairs.forEach(pair => {
        if (!pair.block) pair.block = document.querySelector(pair.blockSelector);
        if (!pair.app) pair.app = document.querySelector(pair.appSelector);

        if (pair.block && pair.app) {       
          switch (pair.type) {
            case 'prepend':
              pair.block.prepend(pair.app);
              break;
            case 'append':
              pair.block.append(pair.app);
              break;
            default:
              pair.block.append(pair.app);
              break;
          }
            pair.app.classList.remove("hidden")
            operationsCompleted++;
            pair.completed = true;
        }
    });

    if (operationsCompleted >= operationCount) {
        clearInterval(pfInterval);
    }
}, 500);

setTimeout(() => {
    clearInterval(pfInterval);
}, 5000);

function handleMutations(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes) {
      mutationsSelectors.forEach(function(selectorObj) {  
        if (selectorObj.from === 'wishlist-button-block') {
          var destination = document.querySelector(selectorObj.to);
          var wishlistButtonBlock = document.getElementsByTagName("wishlist-button-block")[0];
          if (wishlistButtonBlock && destination) {
            destination.appendChild(wishlistButtonBlock);
          }
        } else {
          mutation.addedNodes.forEach(function(node) {
            var fromClass = selectorObj.from.slice(1); // Entfernen des Punkts am Anfang des Selektors
            if (node.classList && node.classList.contains(fromClass)) {
              var target = document.querySelector(selectorObj.target);
              var destination = document.querySelector(selectorObj.to);
              if (target && destination) {
                destination.appendChild(node);
              }
            }
          });
        }
      });
    }
  });
}

mutationsSelectors.forEach(function(selectorObj) {
  var target = document.querySelector(selectorObj.target);
  if (target) {
    var observer = new MutationObserver(handleMutations);
    observer.observe(target, {
      childList: true,
      subtree: true // Set to true if you want to observe the entire subtree of target
    });
  }
});